import { API_MODE, NODE_ENV } from '~/constants/env'

export function matchIsNodeProduction() {
  return NODE_ENV === 'production'
}

export function matchIsReleasedVersion() {
  return matchIsNodeProduction() && API_MODE === 'production'
}
